import './ContactCustomerCare.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CustomerCareSection from './components/CustomerCareSection';
const ContactCustomerCare = props => {
  const {
    fields,
    params,
    rtl
  } = props;
  const {
    item
  } = fields.data;
  if (!item) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(CustomerCareSection, {
    item: item
  }));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default ContactCustomerCare;
const commonStyles = "c1l3gqb7";
const ltrStyles = "l1f05rhd";
const rtlStyles = "r1cca78y";